import ContainerWrapper from "@/components/ui/ContainerWrapper";
import {
  clearImpersonateEmail,
  getImpersonateEmail,
  saveImpersonateEmail,
} from "@/lib/storage-utils";
import { Button } from "@/stories/Button";
import { Flex, Text, TextField } from "@radix-ui/themes";
import { createFileRoute } from "@tanstack/react-router";
import { useState, useEffect } from "react";
import { toast } from "react-toastify";

function ImpersonatePage() {
  const [email, setEmail] = useState("");
  const [savedEmail, setSavedEmail] = useState<string | null>(null);

  useEffect(() => {
    const stored = getImpersonateEmail();
    if (stored) {
      setSavedEmail(stored);
      setEmail(stored);
    }
  }, []);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) {
      toast.error("Please enter an email address");
      return;
    }
    saveImpersonateEmail(email.trim());
    window.location.href = "/";
  };

  const handleClear = () => {
    clearImpersonateEmail();
    setSavedEmail(null);
    setEmail("");
    toast.success("Impersonation cleared");
  };

  return (
    <ContainerWrapper className="py-8">
      <Flex direction="column" gap="6" style={{ maxWidth: 500 }}>
        <Flex direction="column" gap="2">
          <Text size="8" weight="bold">
            Impersonate User
          </Text>
          <Text size="4" color="gray">
            Enter the email address of a user to impersonate
          </Text>
        </Flex>

        <form onSubmit={handleSubmit}>
          <Flex direction="column" gap="4">
            <Flex direction="column" gap="2">
              <label htmlFor="email">
                <Text size="2" weight="medium">
                  Email Address
                </Text>
              </label>
              <TextField.Root
                id="email"
                type="email"
                placeholder="user@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={!!savedEmail}
              />
            </Flex>

            <Flex gap="3">
              {savedEmail ? (
                <Button
                  type="button"
                  onClick={handleClear}
                  label="Clear Impersonation"
                  color="red"
                  variant="soft"
                />
              ) : (
                <Button type="submit" label="Start Impersonating" />
              )}
            </Flex>

            {savedEmail && (
              <Text size="2" color="orange">
                Currently impersonating: {savedEmail}
              </Text>
            )}
          </Flex>
        </form>
      </Flex>
    </ContainerWrapper>
  );
}

export const Route = createFileRoute("/admin/_adminLayout/impersonate")({
  component: ImpersonatePage,
});
